
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import React, { Component } from "react";
import Config from '../../../../dev/config/main';
import PropTypes from 'prop-types';

let attempt = 0;

/**
 * @name playVideo
 * @description helper function to play video
 * @param resetCounter
 * @returns {undefined}
 * */
const playVideo = (resetCounter) => {
    resetCounter && (attempt = 0);
    attempt++;
    setTimeout(function () {
        let video = document.getElementById("live_game_video");
        if (video) {
            video.pause();
            Config.main.video.autoPlay && video.play();
            attempt = 0;
        } else {
            attempt < 25 ? playVideo() : null;
        }
    }, 200);
};

/**
 * @name pauseVideo
 * @description  pause video function
 * @returns {undefined}
 * */
const pauseVideo = () => {
    let video = document.getElementById("live_game_video");
    if (video) {
        video.pause();
    }
};

class AnimationsContainer extends Component {

    /**
     * @name toggleTab
     * @description  activating video tab and playing video if tab's type is video
     * @param tab
     * @returns {undefined}
     * */
    toggleTab (tab) {
        this.activeTab = tab;
        if (tab === 'video' && !this.toggleEnabled) {
            playVideo();
        }
        this.forceUpdate();
    }

    /**
     * @name toggleExpanded
     * @description function which is forcing to update the component for opening video
     * @returns {undefined}
     * */
    toggleExpanded () {
        if (this.activeTab === 'video') {
            !this.toggleEnabled ? pauseVideo() : playVideo(true);
        }
        this.toggleEnabled = !this.toggleEnabled;
        this.forceUpdate();
    }
    UNSAFE_componentWillMount () {
        this.activeTab = this.props.hasAnimation ? 'animation' : 'video';
        if (this.activeTab === 'video') {
            this.toggleEnabled = true;
        }
    }
    componentWillUnmount () {
        let video = document.getElementById("live_game_video");
        video && video.pause();
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

AnimationsContainer.propTypes = {
    hasVideo: PropTypes.bool,
    videoLoadStarted: PropTypes.bool,
    loggedIn: PropTypes.bool,
    balance: PropTypes.number,
    hasAnimation: PropTypes.bool,
    game: PropTypes.object,
    sportAlias: PropTypes.string
};

export default AnimationsContainer;